import React from 'react'
import cx from 'classnames'
import style from './card.module.scss'
import PropTypes from 'prop-types'

const VegaCard = ({ children, className }) => {
	return <div className={cx(style.card, className)}>{children}</div>
}

VegaCard.propTypes = {
	/** Allow to set a classname on the component */
	className: PropTypes.string
}

export { VegaCard }
